<template>
	<div class="activitie-detail">
		<div class="rec">
			<div class="main">
				<van-row type="flex">
					<van-image v-if="item.thumbnail_url" class="img" :src="item.thumbnail_url" fit="cover" />
					<img v-else class="img" src="../../assets/defaultImg.png" />
					<div class="van-multi-ellipsis--l2 title">{{ item.name }}</div>
				</van-row>
				<van-row style="margin-top: 0.75rem;" type="flex" justify="space-between">
					<div class="time">{{ item.start_time }} - {{ item.end_time }}</div>
					<van-tag color="#FF8214">{{ item.statusName }}</van-tag>
				</van-row>
				<div class="van-ellipsis area">{{ item.address }}</div>
				<div class="area">咨询电话：{{ item.help_contact }}</div>
			</div>
		</div>
		<van-tabs v-model="activeName" title-active-color="#1592E6" color="#1592E6" swipeable>
			<van-tab title="详情" name="content">
				<div class="article" v-html="item.content"></div>
				<div class="apply-btn-container">
					<van-button class="apply-btn" block size="large" type="info" @click="applyActivity" :disabled="!status">报名</van-button>
				</div>
			</van-tab>
			<van-tab title="评论" name="comment">
				<comment :type="1" :is_open="is_open" :item="item" :comment_count="comment_count" @getdata="getdata"></comment>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
import Comment from './Comment.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
	data() {
		return {
			activeName: 'content',
			item: {},
			comment_count: 0,
			status: false,
			is_open: true,
		}
	},
	components: {
		comment: Comment,
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	created() {
		this.getdata()
	},
	methods: {
		getdata() {
			this.item = {
				id: '',
				name: '',
				thumbnail_url: '',
				start_time: '',
				end_time: '',
				address: '',
				content: '',
			}
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/activities/${this.$route.query.id}/detail`,
				{},
				(res) => {
					this.item = {
						id: res.data.id,
						name: res.data.name,
						thumbnail_url: res.data.thumbnail_url,
						start_time: moment(parseInt(res.data.start_time)).format('YYYY-MM-DD HH:mm'),
						end_time: moment(parseInt(res.data.end_time)).format('YYYY-MM-DD HH:mm'),
						address: res.data.address,
						help_contact: res.data.help_contact,
						content: res.data.content,
						statusName: this.getStatusName(`${res.data.status}`),
					}
					this.comment_count = res.data.comment_count
					this.is_open = res.data.is_open === 1 //0 关 ， 1 开
					this.status = res.data.status === 1
				},
				function(err) {
					console.log(err)
				}
			)
		},
		getStatusName(id) {
			let statusLists = {
				'1': '未开始',
				'2': '进行中',
				'3': '已结束',
				'4': '审核中'
			}
			return statusLists[id]
		},
		applyActivity() {
			this.status = false
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/activities/enroll`,
				{
					activity_id: this.item.id,
					company_id: this.companyId,
				},
				() => {
					this.$toast('报名成功')
					this.onRefresh()
					this.$emit('getdata')
					this.status = true
				},
				(err) => {
					console.log(err)
					this.status = true
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
	},
}
</script>

<style scoped>
.rec {
	position: relative;
	height: 8.1875rem;
	background-color: #f0f1f3;
}

.main {
	top: 0.46875rem;
	left: 50%;
	transform: translate(-50%);
	width: 82.51%;
	background-color: #ffffff;
	position: absolute;
	padding: 0.75rem 1.65625rem 1.5625rem 1.6875rem;
	border-radius: 0.4375rem;
	box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.04);
}

.img {
	width: 6.25rem;
	height: 4.375rem;
}

.img img {
	border-radius: 0.4375rem;
}

.title {
	font-size: 0.9375rem;
	color: #272727;
	width: 54.67%;
	height: 2.63125rem;
	margin: 0.4375rem 0 0 0.75rem;
}

.time,
.area {
	font-size: 0.875rem;
	color: #8d8d8d;
	margin-left: 0;
}

.van-tag {
	font-size: 0.75rem;
}

.area {
	margin-top: 0.59375rem;
}

.van-tabs {
	margin-top: 4.84375rem;
}

.van-tab {
	font-size: 0.9375rem;
}

.van-tab__pane {
	padding: 1rem;
}

.article {
	min-height: 300px;
	margin-bottom: 1rem;
}

.apply-btn-container {
	height: 44px;
	font-size: 1.125rem;
}

.van-tag {
	white-space: nowrap;
}
</style>
